import React, { createContext, useContext } from 'react';

import todoImg from '../assets/image/TodoListImg2.avif'
import calculator from '../assets/image/Calculator.avif'
import weatherApp from '../assets/image/WeatherApp.avif'
import furnitureWebsite from '../assets/image/Panto.avif'
import grafizen from '../assets/image/grafizen.avif'
import grafizenLogo from '../assets/image/GrafizenLogo.avif'
import onlee from '../assets/image/Onlee.avif'
import onleeLogo from '../assets/svg/OnleeLogo.svg'
import secureForce from '../assets/image/secureForce.avif'
import secureforceLogo from '../assets/image/SecureForceLogo.avif'
import mobilePortfolio from '../assets/image/MobileResponsive.avif'
import mobilePortfolio2 from '../assets/image/MobileResponsive2.avif'
import responsivePortfolio from '../assets/image/ResponsivePortfolio.avif'
import responsivePortfolio2 from '../assets/image/ResponsivePortfolio2.avif'
import socialMediaInfluencer from '../assets/image/SocialMediaInfluencer.avif'
import BlogApp from '../assets/image/BlogApplication.avif'
import GSAPWebsite from '../assets/image/GSAPWebsite.avif'
import ChatApp from '../assets/image/ChatApplication.avif'
import useLocalStorage from 'use-local-storage';

// Create a context
const DataContext = createContext();

const internship = [
    {
        height: '',
        class: 'lg:order-2',
        img: grafizen,
        alt: 'Grafizen Venture',
        logo: grafizenLogo,
        duration: 'May 2023 to October 2023',
        p1: 'This Company helps me learn React technologies, enhances skills and boost my Confidence.',
        p2: "The company's approach was hands-on, allowing me to apply what I learned immediately in practical scenarios."
    },
    {
        height: 'h-20',
        class: '',
        img: secureForce,
        alt: 'SecureForce',
        logo: secureforceLogo,
        duration: 'March 2024 to June 2024',
        p1: 'I gained practical experience in PHP coding, which improved my problem-solving abilities in web development.',
        p2: 'Through this experience, I developed a strong understanding of how design and development work together to create seamless digital experiences'
    },
    {
        height: 'h-8 sm:h-10 md:h-12',
        class: 'lg:order-2',
        img: onlee,
        alt: 'Onlee Agency',
        logo: onleeLogo,
        duration: 'October 2025 to Current',
        p1: 'Gained hands-on experience in Webflow, improving my ability to design and develop responsive, production-ready websites.',
        p2: "Worked on real projects that reinforced practical skills and strengthened my problem-solving approach."
    },
];

const project = [
    {
        name: 'Todo List',
        class_title: '',
        class: '',
        img: todoImg,
        link: 'https://todo-list-drashik.vercel.app/',
        duration: 'July, 2024 - August, 2024',
        p1: 'This todo list application allows users to manage tasks with features for adding, editing, and completing todos. It includes tabs for viewing todos based on their completion status and a search bar for easy filtering.',
        p2: "I assisted in implementing tab-based views, local storage integration, and UI enhancements to ensure the application's smooth functionality."
    },
    {
        name: 'Calculator',
        class_title: 'order-2',
        class: 'lg:order-2',
        img: calculator,
        link: 'https://calculator-darshik.vercel.app/',
        duration: 'August, 2024',
        p1: 'This calculator app, built with React and styled using Tailwind CSS, offers a clean and modern interface with essential arithmetic functions and responsive design.',
        p2: 'It ensures a visually appealing user experience across various devices.'
    },
    {
        name: 'Weather App',
        class_title: '',
        class: '',
        img: weatherApp,
        link: 'https://weather-app-darshik.vercel.app/',
        duration: 'August, 2024',
        p1: 'This weather app fetches real-time data using the OpenWeather API, displaying current conditions with dynamic images and backgrounds based on the weather. It offers a user-friendly interface for searching and viewing weather details for any location.',
        p2: 'The app features a default location, supports user searches, and provides a visually engaging experience with responsive design and appropriate imagery for various temperatures.'
    },
    {
        name: 'Panto Furniture website',
        class_title: 'order-2',
        class: 'lg:order-2',
        img: furnitureWebsite,
        link: 'https://darshik-live-in-lumos.webflow.io/',
        duration: 'April, 2026',
        p1: 'Built a modern one-page furniture website in Webflow while learning the Lumos Framework, focusing on responsive layouts and clean UI design.',
        p2: 'This project helped me practice structured Webflow development, reusable components, and smooth visual interactions in a real-world landing page.'
    },
];

const others = [
    {
        link: "https://darshik-task.netlify.app/",
        img: mobilePortfolio,
        name: "Mobile Responsive Portfolio"
    },
    {
        link: "https://darshik-task1.netlify.app/",
        img: mobilePortfolio2,
        name: "Mobile Responsive Portfolio"
    },
    {
        link: "https://darshik-responsive-portfolio.vercel.app/",
        img: responsivePortfolio,
        name: "Responsive Portfolio"
    },
    {
        link: "https://darshik-responsive-portfolio2.vercel.app/",
        img: responsivePortfolio2,
        name: "Second Responsive Portfolio"
    },
    {
        link: "https://darshik-socialmedia-influencer.vercel.app/",
        img: socialMediaInfluencer,
        name: "Social Media Influencer"
    },
    {
        link: "https://gsap-website-tau.vercel.app/",
        img: GSAPWebsite,
        name: "GSAP Website"
    },
    {
        link: "https://dakulog.vercel.app/",
        img: BlogApp,
        name: "Dakulog Blog Application"
    },
    {
        link: "https://chat-app-bn8k.onrender.com/",
        img: ChatApp,
        name: "Chatty Chat Application"
    },
];


// Context Provider
export const DataProvider = ({ children }) => {

    const [darkMode, setDarkMode] = useLocalStorage("Darshik's-DarkMode", 'dark');
    const toggleDarkMode = () => {
        setDarkMode(darkMode === "dark" ? "light" : "dark")
    }
    const data = { internship, project, others, darkMode, toggleDarkMode };

    return (
        <DataContext.Provider value={data}>
            {children}
        </DataContext.Provider>
    );
};

// Custom hook to use the data
export const useDataContext = () => {
    return useContext(DataContext);
};
